import { useEffect, useState } from "react";
//components
import { Button } from "../components/ui/buttons/Button";
import { Input } from "../components/ui/inputs/Input";
import { InputContainer } from "../components/ui/inputs/InputContainers";
import Label from "../components/ui/labels/Label";
import { PasswordValidationErrors } from "../components/ui/messages/PasswordValidationErrors";
import { APIMessage } from "../components/ui/messages/APIMessage";
//hooks
import { useLoading } from "../contexts/LoadingContext";
import { useLocation, useNavigate } from 'react-router-dom';
import { useError } from "../contexts/ErrorContext";
//utils/api
import { resetPasswordAPI } from "../services/authAPI"
import { validatePassword } from "../utils/validatePassword";

/**
 * When user clicks "Forgot Password" they receive an email with a link to reset it. This page opens when the link is followed. User can reset their password here.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const ResetPassword = () => {
    //set state
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const [validationErrors, setValidationErrors] = useState({})

    const {showLoading, hideLoading} = useLoading()
    const navigate = useNavigate()
    const {showError} = useError()

    //get token
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    //validation
    const validate = () => {
        const errors = {}

        const passwordErrors = validatePassword(password);

        if (passwordErrors.length > 0) {
          errors.password = passwordErrors
        }

        else if(!confirmPassword){
            errors.confirmPassword = "Please confirm password"
        }
        else if(password !== confirmPassword){
            errors.confirmPassword = "Passwords don't match"
        }
        
        //if there are errors, set state to errors and return false
        if(Object.keys(errors).length > 0){
            setValidationErrors(errors)
            showError("Could not reset password - some form fields are missing")
            return false
        }

        setValidationErrors({})

        return true
    }

    //submit
    const handleSubmit = async() => {
        showLoading("Resetting password...")

        if(!validate()){
            hideLoading()
            return
        }

        const response = await resetPasswordAPI({
            password,
            resetToken: token
        })
                     
        if(!response.success){
            showError(response.message)
            setPassword("")
            setConfirmPassword("")
            
            hideLoading()
            
            return
        }

        showLoading("Password changed successfully. Redirecting to login...")
        setPassword("")
        setConfirmPassword("")


        setTimeout(() => {
            hideLoading()
            navigate('/login')
        }, 2000);
        
    }

    useEffect(() => {
        document.title =  `MarTrak - Reset Password`
    }, []);

    return(
        <>
            
            {/* <PageContainer> */}
            <div className="flex items-center justify-center bg-white">
                <div className="flex flex-col p-8 mb-0 space-y-4 rounded-lg shadow-2xl bg-white">
                <p className="text-lg font-medium text-center text-gray-700">
                        Reset your password
                    </p>
                {/* password */}
                <InputContainer>
                    <Label htmlFor='pass' className='mb-2 font-semibold'>Password</Label>
                    <Input 
                        type='text' 
                        name="pass" 
                        value={password} 
                        onChange={(e)=>setPassword(e.target.value)}
                        error={validationErrors.password}
                        className="obscured-password"
                    />
                    <PasswordValidationErrors validationErrors={validationErrors} className="my-1 italic text-sm"/>
                </InputContainer>

                {/* confirm password */}
                <InputContainer>
                    <Label htmlFor='confirmPassword' className='mb-2 font-semibold'>Confirm password</Label>
                    <Input 
                        type='text' 
                        name="confirmPassword" 
                        value={confirmPassword} 
                        onChange={(e)=>setConfirmPassword(e.target.value)}
                        error={validationErrors.confirmPassword}
                        className="obscured-password"
                    />
                    <APIMessage message={validationErrors.confirmPassword} isError={true} className="my-1 italic text-sm"/>
                </InputContainer>

                    <Button onClick={() => handleSubmit()}>Reset Password</Button> 

                </div>
                </div>

            {/* </PageContainer> */}
        </>
    )
}